import { axios } from '@Api/axiosClient';
import type { Location } from '@Shared';


const baseUrl: string = 'api/Company';


export const getLocationFromSessionApi = async (): Promise<Location | null> => {
    const response = await axios.get(`${baseUrl}/GetLocationInfo`);
    return response ? response.data : null;      
};

export const getCompanyFromSessionApi = async (): Promise<Company | null> => {
    try {
        const response = await axios.get(`${baseUrl}/GetCompanyInfoFromSession`);
        return response.data ?? null;
    } catch (error) {
        return null;
    }
};
